// extracted by css-extract-rspack-plugin
export default {"container":"_ff5e7ce2","inputWrapper":"_ed1ca1c0","anchor":"_60aa679c","label":"_53d51963","disabled":"_fe0be275","count":"_40de2ba6"};